import { AppState } from '../models/state/appState';
import {
  BoltOnsState,
  DropdownItemsState,
  ExcludedProvisioningDaysState,
} from '../models/state/simProvision/simProvisionState';

/**
 * Selects the tariff standard bolt-ons
 * @param state The application state.
 */
export function selectTariffBoltOns(state: AppState): BoltOnsState {
  return state.simProvisionState.boltOns;
}

/**
 * Selects the tariff temporal bolt-ons
 * @param state The application state.
 */
export function selectTariffTemporalBoltOns(state: AppState): BoltOnsState {
  return state.simProvisionState.temporalBoltOns;
}

/**
 * Selects the network bundle top-ups
 * @param state The application state.
 */
export function selectBundleTopups(state: AppState): DropdownItemsState {
  return state.simProvisionState.bundleTopupSizes;
}

/**
 * Selects the network tariffs
 * @param state The application state.
 */
export function selectTariffs(state: AppState): DropdownItemsState {
  return state.simProvisionState.tariffs;
}

/**
 * Selects the excluded provisioning days
 * @param state The application state.
 */
export function selectExcludedProvisioningDays(state: AppState): ExcludedProvisioningDaysState {
  return state.simProvisionState.excludedProvisioningDays;
}
